<p-toast></p-toast>
<p-dialog
  dismissableMask
  modal
  [(visible)]="visible"
  [style]="{ width: '640px' }"
  [breakpoints]="{ '600px': '95vw' }"
>
  <ng-template #header>
    <div class="dialog-header">
      <span class="dialog-title">
        {{ "duplicateCard.title" | translate }}
      </span>
    </div>
  </ng-template>
  <div class="dialog-body">
    <p class="description">
      {{ "duplicateCard.description" | translate: user() }}
    </p>
    <button
      pButton
      class="confirm-btn"
      [loading]="sendingRequest()"
      (click)="onConfirm()"
    >
      {{ "duplicateCard.confirm" | translate }}
    </button>
  </div>
</p-dialog>
